import {ref, unref} from 'vue';
import {loadDomainList, loadListByUrl} from "@/api/domainApi/domainComApi";
import {useDataSourceStore} from "@/store/modules/dataSourceStore";
import {usePageModelsStore} from "@/store/modules/pageModels";
import {deepClone} from "xmgoing-utils";
import GoingUtils from "@/utils/goingUtils";
import {StorageUtils} from "xmgoing-utils";
import {getCurrentDate, getCurrentMonth, getCurrentYear, getCurrentYearMonth} from "xmgoing-utils";

/**
 * 系统参数集合
 */
export const systemParamsMap = {
  sessionId: StorageUtils.getSessionItem("sessionId"),
  projectI18n: StorageUtils.getItem("projectI18n"),
  currentYear: getCurrentYear(),
  currentYearMonth: getCurrentYearMonth(),
  currentDate: getCurrentDate(),
  currentMonth: getCurrentMonth()
}

function initFilterValueByType({valueType,propItem,pageModelsStore,filterValue}){
  //如果是全局变量
  if(valueType==='vuexParams'){
    if(pageModelsStore&&pageModelsStore.state){
      propItem.filterValue=pageModelsStore.state[unref(filterValue)]||"";
    }
  }
  if(valueType==='systemParams'){
    propItem.filterValue=systemParamsMap[unref(filterValue)]||"";
  }
}


export function getFilterJson(filter, filterRelVal,pageModelsStore) {
  filter=deepClone(filter);
  if(filter&&Array.isArray(filter)){
    filter.forEach((propItem,index)=>{
      const {valueType,filterValue}=propItem;
      initFilterValueByType({valueType,propItem,pageModelsStore,filterValue});
      //如果为空就移除了
      if(propItem.filterValue==null||propItem.filterValue===''){
        filter.splice(index,1)
      }
    })
  }
  if (filter && filter.length > 0) {
    return {filterRelVal, children: filter};
  } else {
    return {};
  }
}

export default function (dataConfig: any, pageSize = 10000) {
  const tableDs: any = ref([]);
  const loadingFlag: any = ref(true);
  const pageTotal: any = ref(0);
  const tableLoading: any = ref(false);
  //默认查询第一页
  const current = ref(1);
  const dataSourceStore = useDataSourceStore();
  const pageModelsStore=usePageModelsStore();
  const loadListDataByQueryUrl = async function (backFun?: any,queryParams?:any,method?:any) {
    if(unref(dataConfig)==null){
      return;
    }
    if (unref(dataConfig).queryUrl) {
      const datas = await loadListByUrl({
        queryParams,
        url:unref(dataConfig).queryUrl,
        method,
        current: unref(current),
      });
      if (datas == null) {
        tableLoading.value = false;
        return
      }
      pageTotal.value = datas.total;
      if (unref(dataConfig).waitSelCols) {
        /**
         * 设置映射字段信息
         */
        datas.records.forEach((recordObj: any) => {
          unref(dataConfig).waitSelCols.forEach(({value, mapField}) => {
            recordObj[value] = recordObj[mapField];
          })
        })
      }
      backFun && backFun({res:datas});
    } else {
      backFun && backFun([]);
    }
    tableLoading.value = false;
  }

  /**
   * 清空缓存
   */
  const clearDs=function (){
    dataSourceStore.removeCacheByCode(unref(dataConfig).selId);
  }
  /**
   * 加载数据
   * 通过领域查询
   */
  const loadListDataByQuery = async function (backFun?: any,queryParams?:any) {
    const {filter, filterRelVal} = unref(dataConfig);
    const filterStr = JSON.stringify(getFilterJson(filter, filterRelVal,pageModelsStore));
    const orderFieldList=unref(dataConfig).orderFieldList;
    const orderParams={};
    if(orderFieldList&&orderFieldList.length>0){
      orderFieldList.forEach((itemDb)=>{
        orderParams[`${itemDb.propId}_${itemDb.orderType}`]=itemDb.orderType;
      })
    }
    if (unref(dataConfig).domainCode) {
      const datas = await loadDomainList({
        pageCode: unref(dataConfig).domainCode,
        pageSize: pageSize || (unref(dataConfig)&&unref(dataConfig).pageSize)||GoingUtils.maxPageSize,
        formula: filterStr,
        current: unref(current),
        queryParams:{...queryParams,...orderParams}
      });
      if (datas == null) {
        tableLoading.value = false;
        return
      }
      pageTotal.value = datas.total;
      if (unref(dataConfig).waitSelCols) {
        /**
         * 设置映射字段信息
         */
        datas.records.forEach((recordObj: any) => {
          unref(dataConfig).waitSelCols.forEach(({value, mapField}) => {
            recordObj[value] = recordObj[mapField];
          })
        })
      }
      backFun && backFun({res:datas});
    } else {
      backFun && backFun([]);
    }
    tableLoading.value = false;
  }

  /**
   * 加载数据 通过vuex的数据源信息获取
   */
  const loadListDataByVuexDs = function (backFun?: any,queryParams:any) {
    if (unref(dataConfig).selId) {
      if(unref(dataSourceStore.dataLoadFlags)[unref(dataConfig).selId]){
        backFun&&backFun({res:unref(dataSourceStore.dataListCache)[unref(dataConfig).selId]});
      }else{
        dataSourceStore.getDatasByQueryCode(unref(dataConfig).selId,pageModelsStore,({res})=>{
          backFun&&backFun({res});
        },()=>{},queryParams);
      }

    }else{
      backFun && backFun([]);
    }
    tableLoading.value = false;
  }

  const initCtlData = function (backFun?: any,queryParams?:any) {
    if(queryParams==null){
      queryParams={};
    }
    if(unref(dataConfig)==null){
      return;
    }
    //数据来源类型
    if (unref(dataConfig).dataFormType === "static") {
      tableDs.value = unref(dataConfig).list;
      return;
    }
    //如果加载中 则不用继续执行
    if (unref(tableLoading)) {
      return;
    }
    tableLoading.value = true;
    if (dataConfig == null) {
      return;
    }
    if (unref(dataConfig).userDef===true||unref(dataConfig).userDef==="true") {
      loadListDataByQuery(backFun,queryParams);
    }else if(unref(dataConfig).queryUrl){
      loadListDataByQueryUrl(backFun,queryParams,unref(dataConfig).method);
    } else {
      //如果是选择数据源的数据
      loadListDataByVuexDs(backFun,queryParams);
    }
  }

  const setPageCurrent = function (currentVal: number,params) {
    current.value = currentVal;
    initCtlData(()=>{},{...params,current:currentVal});
  }


//翻页操作
  const changePage = ({current,backFun}) => {
    setPageCurrent(current,{});
    backFun&&backFun();
  }

  return {
    clearDs,
    changePage,
    setPageCurrent,
    tableLoading,
    pageTotal,
    loadingFlag,
    initCtlData,
    tableDs
  }
}
